const axios = require('axios');
const hostname = window.location.hostname;
var $api = '';
if(hostname.includes('localhost')) {
  // $api = 'http://localhost:3000/v1';
  $api = 'https://www.srsoa.cn/v1';
} else {
  $api = 'https://www.srsoa.cn/v1';
}
import router from '../router/index';

export default function main($message, callback) {
  const data = JSON.parse(localStorage.getItem('logdata'));
  axios.get($api + '/organization/login', { params: data }).then(res => {
    if(res.data.code == 200) {
      const user = res.data.item;
      const header = {
        Authorization: user.token,
      }
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('header', JSON.stringify(header));
      localStorage.setItem('logTime', Date.now());
      delete data.password;
      localStorage.setItem('logdata', JSON.stringify(data));
      if(typeof callback == 'function') callback();
    } else {
      $message.error('登录过期，请重新登陆');
      router.replace('/backend/login');
    }
  }).catch(() => {
    $message.error('登录过期，请重新登陆');
    router.replace('/backend/login');
  });
}